/**
 * Toggle accordion sections
 *
 * @return {void}
 */

const $doc = $(document);
const activeClass = 'is-active';

$doc.on('click', '.accordion .accordion__head', function() {
  let $accHead = $(this);
  let $acc = $accHead.closest('.accordion__section');

  $accHead.next().slideToggle();
  $acc.toggleClass(activeClass);
});
